import { render, staticRenderFns } from "./loja.html?vue&type=template&id=dccf60d6&scoped=true&"
import script from "./loja.vue?vue&type=script&lang=js&"
export * from "./loja.vue?vue&type=script&lang=js&"
import style0 from "./loja.less?vue&type=style&index=0&id=dccf60d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf60d6",
  null
  
)

export default component.exports